import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HvSvg from 'src/components/HvSvg';

import Icon from './Icon';

import Modal from './Modal';

const DefaultContentStyle = {
  textAlign: 'center',
  padding: '43px 30px 30px',
  display: 'flex',
  flexDirection: 'column',
};

// flex for the overflow scrolling
const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

const Title = styled.div`
  ${({ theme }) => theme.mixins.fontWeights.bookImportant}
  font-size: ${({ theme }) => theme.utils.pxToRem(24)}rem;
  margin-bottom: ${({ theme }) => theme.utils.pxToRem(10)}rem;
`;

const Message = styled.div`
  font-size: ${({ theme }) => theme.utils.pxToRem(13)}rem;
  line-height: ${18 / 13};
  margin-bottom: ${({ theme }) => theme.utils.pxToRem(28)}rem;
`;

// flex for the overflow scrolling
const Content = styled.div`
  overflow-y: auto;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  margin: 0 ${({ theme }) => theme.utils.pxToRem(15)}rem !important;
`;

const CloseButton = styled.div`
  position: absolute;
  top: 14px;
  right: 13px;

  .hv-svg svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
    cursor: pointer;
  }
`;

export default class DefaultModal extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    action: PropTypes.element.isRequired,
    cancel: PropTypes.element,
  };

  static defaultProps = {
    title: '',
    message: '',
    cancel: null,
  };

  render() {
    const {
      isOpen,
      title,
      message,
      action,
      cancel,
      contentStyle,
      closeButton,
      ...otherProps
    } = this.props;

    return (
      <Modal
        contentStyle={{
          ...DefaultContentStyle,
          ...contentStyle,
        }}
        {...otherProps}
        isOpen={isOpen}
      >
        <Container>
          {closeButton && (
            <CloseButton size="13" role="button" onClick={closeButton}>
              <HvSvg disabled={false} src={require('src/assets/icons/x.svg')} />
            </CloseButton>
          )}
          <Title>{title}</Title>
          <Message>{message}</Message>
          <Content>{this.props.children}</Content>
          <Footer>
            {!!cancel && <ButtonWrapper>{cancel}</ButtonWrapper>}
            <ButtonWrapper>{action}</ButtonWrapper>
          </Footer>
        </Container>
      </Modal>
    );
  }
}
